import React, {createContext, useContext, useEffect, useState} from "react";
import {IAuth, IMenuItems} from "../types";
import {fetchAuth} from "../store/pages/profile/actions";
import {useDispatch, useSelector} from "react-redux";
import {Cookies, useCookies} from "react-cookie";
import {COOKIE_KEY} from "../constants";
import {getFromUrl} from "../utils/getFromUrl";
import {selectStore} from "../store/selector";
import {RootState} from "../store";

const cookies = new Cookies();

const initialState: IAuth = {
  isAuth: false,
  role: '',
  handleLogin: (values) => new Promise(() => {
  }),
  handleLogout: () => new Promise(() => {
  }),
  menu: [],
}


/**
 * @description set token cookie
 */
export const setTokenCookie = (token: string | null) => {
  cookies.set(COOKIE_KEY.ACCESS_TOKEN, token, {path: '/'})
}

export const removeTokenCookie = () => {
  cookies.remove(COOKIE_KEY.ACCESS_TOKEN, { path: '/' })
}

const AuthContext = createContext<IAuth>(initialState);
export const AuthProvider = ({children}: any) => {
  const dispatch = useDispatch()
  const [cookie, setCookie, removeCookie] = useCookies([COOKIE_KEY.ACCESS_TOKEN])

  const {profile: {menu: menuState, userProfile: userProfileState}}: RootState = useSelector(selectStore)

  const [isAuth, setIsAuth] = useState<boolean>(!!cookie[COOKIE_KEY.ACCESS_TOKEN]);
  const [menu, setMenu] = useState<IMenuItems[]>(menuState.data)
  const [role, setRole] = useState<string>('')

  useEffect(() => {
    if (menuState.success) {
      setMenu(menuState.data);
    }
  }, [menuState.success]);

  useEffect(() => {
    if (userProfileState.success) {
      setRole(userProfileState.data?.person_type)
    }
  }, [userProfileState.success])

  useEffect(() => {

    const cookiesHandler = (options: any) => {
      if (options.name === COOKIE_KEY.ACCESS_TOKEN) {
        if (options.value !== undefined) {
          setIsAuth(true)
        } else {
          setIsAuth(false)
        }
      }
    }

    cookies.addChangeListener((options) => {
      cookiesHandler(options)
    })

    return () => {
      cookies.removeChangeListener((options) => {
        cookiesHandler(options)
      })
    }
  }, [cookie])

  useEffect(() => {
    if (getFromUrl('jwt')) {
      handleSetJwt(getFromUrl('jwt'))
    }
  }, [])

  const handleLogin = async (values: any) => {
    dispatch(fetchAuth(values))
  };

  const handleSetJwt = (token: string | null) => {
    setTokenCookie(token)
  }

  const handleLogout = async () => {
    removeTokenCookie()
  };

  return (
    <AuthContext.Provider
      value={{isAuth, handleLogin, handleLogout, menu, role}}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext)